import Vue from 'vue'
import axios from 'axios'
const api = axios.create({
    baseURL: 'https://howardlee.cn/lantern/lapi',
    // baseURL: 'http://120.26.233.153:8888/lapi',
    withCredentials: true,
})

Vue.prototype.$http = api

async function getTables(db) {
    return api.get('tables/' + db)
}

async function login(email, institute, ipaddress) {
    return api.post('login', {
        email: email,
        institute: institute,
        ipaddress: ipaddress
    })
}

async function ask(question) {
    return api.post('qa', {
        question: question
    })
}

async function askNoNLP(question, email) {
    return api.post('qa', { 'question': question, 'email': email }, {
        params: {
            nonlp: "yes"
        }
    })
}

async function queryPoem(statement, db) {
    return api.post('getPoem/' + db, {
        statement: statement
    })
}

async function feedback(email, feedback) {
    return api.post('feedback', {
        email: email,
        feedback: feedback
    })
}

async function getPlan(sql, db, email) {
    return api.post('sql/' + db, {
        sql: sql,
        email: email
    })
}
async function GetList(query) {
    return api.get('poem/query', {
        params: query
    })
}

async function AddObj(obj) {
    return api.post('poem/add', {
        data: obj
    })
}

async function UpdateObj(obj) {
    return api.post('poem/update', {
        data: obj
    })
}
async function DelObj(id) {
    return api.post('poem/delete', {
        data: { id }
    })
}
async function configurePoem(statement) {
    return api.post('poem/pool', {
        statement: statement
    })
}
export {
    getTables,
    login,
    ask,
    askNoNLP,
    feedback,
    queryPoem,
    getPlan,
    GetList,
    AddObj,
    UpdateObj,
    DelObj,
    configurePoem
}
